import { Card } from 'antd';
import { ExaminationContainer } from 'components/common/container';
import React from 'react';
import styled from 'styled-components';

const StyledCard = styled(Card)`
    div {
        border: none;
        padding: 0;
    }

    padding-top: 24px;
`;

type Props = {
    title: string;
    loading?: boolean;
    children: React.ReactNode;
};

const DetailsWrapper = ({ loading, title, children }: Props) => (
    <ExaminationContainer text={title}>
        <StyledCard bordered={false} loading={loading}>
            {children}
        </StyledCard>
    </ExaminationContainer>
);

export default DetailsWrapper;
